module.exports = __webpack_public_path__ + "img/menucn_1_1.aedd8542.svg";